export default __webpack_public_path__ + "static/media/screenshot-1.971a613e.png";